<script setup>
  import { onMounted, computed } from 'vue';
  import { useOtherCartStore } from '../../stores/OtherCartStore';
  import Loader from '../ui/Loader.vue';
  import { useI18n } from 'vue-i18n';

  const { t } = useI18n();
  const props = defineProps({
    offer_id: {
      type: Number,
      required: true
    },
    cart_id: {
      type: String,
      required: true
    }
  });
  const otherCartStore = useOtherCartStore();
  const loading = computed(() => {
    return otherCartStore.loading;
  });
  const carts = computed(() => {
    return otherCartStore.carts;
  });

  onMounted(() => {
    otherCartStore.fetchCarts(props.cart_id, props.offer_id);
  });
</script>

<template>
  <div v-if="loading">
    <Loader />
  </div>
  <table class="table" v-if="!loading">
    <thead>
      <tr>
        <th scope="col">{{ t('cart.offer.title') }}</th>
        <th scope="col">{{ t('cart.offer.username') }}</th>
      </tr>
    </thead>
    <tbody v-if="carts">
      <tr v-for="cart in carts" :key="cart.id">
        <td>
          <router-link :to="`/carts/${cart.id}`" replace>
            {{ cart.name }}
          </router-link>
        </td>
        <td>{{ cart.user_name }}</td>
      </tr>
    </tbody>
  </table>
</template>
